import PropTypes from 'prop-types';

const Popover = ({ custumClass, children, ...props }) => {
    return (
        <div className={`${" flex flex-col justify-between "}${custumClass}`}>
            {children}
        </div>
    )
}

Popover.propTypes = {
    custumClass:PropTypes.string
}

export default Popover;
